import { CommonModule } from '@angular/common';
import { Component, Input, signal, inject, computed } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { DynamicEntryComponent, DynamicEntryComponentCrmConfig } from '../dynamic-options';
import { map, Observable, of } from 'rxjs';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { AUTOMATION_DEFAULT_CURRENCY_CODE } from '@galaxy/automata/shared';
import { toSignal } from '@angular/core/rxjs-interop';

// the value format should match the model so need to use '_' case
interface CurrencyData {
  value: number;
  currency_code: string;
}

@Component({
  selector: 'automata-crm-currency-input',
  templateUrl: './crm-currency-input.component.html',
  imports: [CommonModule, TranslateModule, FormsModule, GalaxyFormFieldModule, ReactiveFormsModule, GalaxyInputModule],
})
export class CrmCurrencyInputComponent implements DynamicEntryComponent {
  @Input()
  set initialValue(value: CurrencyData | number) {
    if (typeof value === 'number') {
      this.control.setValue(value);
      this.controlCurrencyCode.set('');
    } else {
      this.control.setValue(value?.value || 0);
      this.controlCurrencyCode.set(value?.currency_code || '');
    }
  }
  selectedValue$: Observable<CurrencyData>;
  @Input() showVariableItemMenu: boolean;

  @Input() label = '';
  @Input() config: DynamicEntryComponentCrmConfig;

  control: FormControl<number | null>;
  controlCurrencyCode = signal<string>('');
  defaultCurrencyCode = toSignal(inject(AUTOMATION_DEFAULT_CURRENCY_CODE, { optional: true }) || of(''));
  selectedCurrencyCode = computed(() => {
    return this.controlCurrencyCode() || this.defaultCurrencyCode() || 'USD';
  });

  constructor() {
    this.control = new FormControl<number | null>(0);
    this.selectedValue$ = this.control.valueChanges.pipe(map(() => this.getSelectedValue()));
  }

  getSelectedValue(): CurrencyData {
    return {
      value: this.control.value || 0,
      currency_code: this.selectedCurrencyCode(),
    };
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.control];
  }

  isFormValid(): boolean {
    return this.control.valid;
  }
}
